import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../components/table";
import { TailSpin } from "react-loader-spinner";

const ReportTable = ({ data, currentPage, onPageChange }: any) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const columns = [
    //   { header: "Case ID", accessor: "orderId" },
    { header: "Email Address", accessor: "email" },
    { header: "Name", accessor: "fullname" },
    { header: "Status", accessor: "status" },
    { header: "Date", accessor: "created_at" },
    { header: " ", accessor: "id" },
  ];

  const mappedData = data.map((report: any) => ({
    ...report,
    email: report.reportedMerchant.email,
    fullname: report.reportedMerchant.fullname,
    status: report.reportedMerchant.status,
    created_at: report.reportedMerchant.created_at,
  }));

  const handleUserClick = (id: string) => {
    navigate(`/report/${id}`);
  };
  return (
    <div className="rounded-md py-3 px-3 bg-white border border-[#fff] mt-10 w-[95%] pt-5 ">
      <p className="text-[18px] font-semibold">Reports</p>

      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <TailSpin color="skyblue" />
        </div>
      ) : mappedData.length > 0 ? (
        <Table
          columns={columns}
          data={mappedData}
          selectedUserId={null}
          onUserClick={handleUserClick}
          currentPage={currentPage}
          onPageChange={onPageChange}
        />
      ) : (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500 text-lg">No data available</p>
        </div>
      )}
    </div>
  );
};

export default ReportTable;
